import { useQuery } from "@tanstack/react-query";
import { fetchSite } from "./api";

/**
 * Everything known about one point, in a single request.
 *
 * Reading these from the map tiles would be free, but only for layers the user
 * has switched on — and a saved shortlist entry needs its readings regardless.
 * One request per click is cheap; clicks are rare compared with pans.
 */
export function useSite(lon: number, lat: number) {
  return useQuery({
    queryKey: ["site", lon.toFixed(5), lat.toFixed(5)],
    queryFn: () => fetchSite(lon, lat),
    staleTime: Infinity,
  });
}
